module.exports = __webpack_public_path__ + "static/media/design.f80d84a1.svg";